<template>
  <v-app>
    <Snackbar></Snackbar>

    <v-app-bar v-if="isLoggedIn" app color="primary" dark dense>
      <v-btn icon large>
        <v-avatar size="32px" item>
          <v-img src="/static/taptarget-logo-white.png"> </v-img>
        </v-avatar>
      </v-btn>

      <v-toolbar-title
        v-if="$vuetify.breakpoint.mdAndUp"
        style="width: 300px"
        class="ml-0 pl-4"
      >
        <span class="hidden-sm-and-down font-weight-bold">
          TapTarget Key Vault
        </span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <slot name="appBarButtonsRight"></slot>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon @click="toggleSplitView">
            <v-icon>{{
              isSplitView ? "close_fullscreen" : "splitscreen"
            }}</v-icon>
          </v-btn>
        </template>
        <span>{{ isSplitView ? "Splitscreen sluiten" : "Splitscreen" }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            class="mr-2"
            target="_blank"
            rel="noopener noreferrer"
            @click="logout"
            ><v-icon>logout</v-icon></v-btn
          >
        </template>
        <span>Logout</span>
      </v-tooltip>
    </v-app-bar>

    <v-main fill-height>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Snackbar from "@/components/base/Snackbar.vue";
import msalAuth from "@/utils/msalAuth.js";

export default {
  name: "App",
  components: {
    Snackbar,
  },

  data() {
    return {};
  },

  created() {
    this.setupMsalAuth();
  },

  computed: {
    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    },

    isSplitView() {
      return this.$store.getters["user/getSplitView"];
    },
  },

  methods: {
    toggleSplitView() {
      const newSplitViewState = !this.isSplitView;
      this.$store.dispatch("user/setSplitView", newSplitViewState); // Dispatch Vuex action to toggle
    },

    setupMsalAuth() {
      // Basic setup of MSAL helper with client id, or give up
      if (process.env.VUE_APP_MSAL_CLIENT_ID) {
        msalAuth.configure(process.env.VUE_APP_MSAL_CLIENT_ID, false);

        // Restore any cached or saved local user
        this.msalUser = msalAuth.user();
        // console.log(`configured ${msalAuth.isConfigured()}`);
      } else {
        this.error =
          "VUE_APP_MSAL_CLIENT_ID is not set, the app will not function!";
      }
    },

    // Full logout local & server side
    async logout() {
      try {
        await msalAuth.logout();
        this.$store.commit("user/setIsLoggedOut");
        this.$router.push("/login");
      } catch (err) {
        console.log(err);
        this.error = err.toString();
      }
    },
  },
};
</script>
